var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UrgenceSkipReasonEnum, } from "../types/enforcement";
import { hasHttpResponse } from "./apiUtils";
/**
 * The one place that turns the skipped records of an urgence batch into the sentence the
 * user reads, so every send dialog explains a partial send the same way.
 */
export var summarizeSkippedRecords = function (skipped, formatMessage) {
    if (!(skipped === null || skipped === void 0 ? void 0 : skipped.length)) {
        return null;
    }
    var alreadyReminded = skipped.filter(function (record) { return record.reason === UrgenceSkipReasonEnum.REMINDER_ALREADY_SENT; }).length;
    var alreadyEnforced = skipped.filter(function (record) {
        return record.reason === UrgenceSkipReasonEnum.ACTIVE_ENFORCEMENT_EXISTS;
    }).length;
    // A reason this build does not know must not be dressed up as one it does — the module can add
    // one at any time, and since RECEK-73672 this summary is also shown as a FORECAST before sending.
    var unknown = skipped.length - alreadyReminded - alreadyEnforced;
    var reasons = [];
    if (alreadyReminded > 0) {
        reasons.push(formatMessage({
            id: "ui-br-legaldeposits.enforcement.skipped.reason.alreadyReminded",
        }, { count: alreadyReminded }));
    }
    if (alreadyEnforced > 0) {
        reasons.push(formatMessage({
            id: "ui-br-legaldeposits.enforcement.skipped.reason.activeEnforcement",
        }, { count: alreadyEnforced }));
    }
    if (unknown > 0) {
        reasons.push(formatMessage({ id: "ui-br-legaldeposits.enforcement.skipped.reason.other" }, { count: unknown }));
    }
    return formatMessage({ id: "ui-br-legaldeposits.enforcement.skipped.summary" }, { count: skipped.length, reasons: reasons.join(" ") });
};
/**
 * Reads the domain code the module puts on a rejected urgence, so the dialog can say WHY
 * the batch was refused instead of showing an unexplained failure. A reminder that lost the
 * race with another one comes back as 409, everything else as 422 with a code in the body.
 */
export var readUrgenceErrorCode = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var body, _a;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                // ErrorHandlingAdvice keeps the domain code on both of these: 422 for a refused batch, 409 for
                // a reminder that lost the race to another request.
                if (!hasHttpResponse(error) ||
                    (error.response.status !== 422 && error.response.status !== 409)) {
                    return [2 /*return*/, null];
                }
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4 /*yield*/, error.response.clone().json()];
            case 2:
                body = (_e.sent());
                return [2 /*return*/, (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : null];
            case 3:
                _a = _e.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * The one place that turns a finished batch into the sentence the user reads. A batch that sent
 * nothing, one whose mail bounced and one recorded by phone all look the same in the response
 * apart from two fields, and the user has to be able to tell them apart.
 */
export var describeSendResult = function (result, kind, formatMessage) {
    var _a, _b;
    if (!result) {
        return null;
    }
    var count = (_b = (_a = result.processed) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    if (count === 0) {
        return {
            type: "warning",
            text: formatMessage({
                id: "ui-br-legaldeposits.enforcement.send.result.nothingSent",
            }),
        };
    }
    if (result.deliveryStatus === "FAILED") {
        return {
            type: "error",
            text: formatMessage({ id: "ui-br-legaldeposits.enforcement.send.result.failed" }, { kind: kind }),
        };
    }
    return {
        type: "success",
        text: formatMessage({
            id: result.deliveryStatus === null || result.deliveryStatus === undefined
                ? "ui-br-legaldeposits.enforcement.send.result.recorded"
                : "ui-br-legaldeposits.enforcement.send.result.sent",
        }, { kind: kind, count: count }),
    };
};
